import React, { useEffect } from "react";
import { TourBanner } from "../components/tourDetails/TourBanner";
import { useLocation, useNavigate } from "react-router-dom";
import "../components/componentsStyle.scss";
import { Timline } from "../components/tourDetails/Timline";

export const InteneraryPage = ({ languageId }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const data = location?.state;

  useEffect(() => {
    if (!data) {
      navigate("/tours-experiences", { replace: true });
    }
  }, [data, navigate]);

  // Prevent render before redirect
  if (!data) return null;

  return (
    <div className="intineraryContainer">
      <TourBanner data={data} languageId={languageId} />
      <Timline data={data} languageId={languageId} />
    </div>
  );
};
